import { Map as ImmutableMap, List } from 'immutable';

type $tsMigrateAny = any;

const INTERNAL_URL_PATTERN = new RegExp(
  '(local.*|tools.*).(hubspot|hubteam)(qa)?.com'
);

export const buildTag = (
  tagName: $tsMigrateAny,
  contents: $tsMigrateAny,
  attrs = {}
) => {
  let attrStr = '';
  if (Object.keys(attrs).length) {
    attrStr = Object.keys(attrs)
      // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      .filter((k) => attrs[k])
      // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      .map((k) => `${k}="${attrs[k]}"`)
      .join(' ');
    if (attrStr.length) {
      attrStr = ` ${attrStr}`;
    }
  }

  return `<${tagName}${attrStr}>${contents}</${tagName}>`;
};

export function memoize(func: $tsMigrateAny) {
  let _cache = ImmutableMap();

  return (...args: $tsMigrateAny[]) => {
    const argList = List.of(...args);
    if (!_cache.has(argList)) {
      _cache = _cache.set(argList, func(...args));
    }
    return _cache.get(argList);
  };
}

export const toggleInlineStyleOverride = (
  editorState: $tsMigrateAny,
  styleLookupSet: $tsMigrateAny
) => {
  let currentInlineStyleOverride = editorState.getInlineStyleOverride();

  if (currentInlineStyleOverride === null) {
    currentInlineStyleOverride = editorState.getCurrentInlineStyle();
  }

  return currentInlineStyleOverride.subtract(styleLookupSet);
};

export function ensureUrlHasProtocol(url: $tsMigrateAny) {
  const trimmed = url.trim();
  if (!url || !trimmed) {
    return url;
  }
  const hasProtocol =
    trimmed.includes('://') ||
    trimmed.includes('tel:') ||
    trimmed.includes('mailto:');
  if (hasProtocol) {
    return url;
  }
  return `http://${url}`;
}

export function encodeUrl(url: $tsMigrateAny) {
  // If the url contains a template variable, don't encode it
  const templateVariablePattern = /\{\{.*?\}\}/g;
  if (templateVariablePattern.test(url)) {
    return url;
  }
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.pathname = decodeURIComponent(anchor.pathname);

  return anchor.href;
}

export function isInternal() {
  return INTERNAL_URL_PATTERN.test(window.location.hostname);
}

export function getImageDimensions(blob: $tsMigrateAny) {
  const image = new Image();
  image.src = blob;
  return new Promise<any>((resolve) => {
    image.onload = function () {
      resolve({
        width: (this as $tsMigrateAny).width,
        height: (this as $tsMigrateAny).height,
      });
    };
  });
}
